import { Routes, Route, Outlet } from "react-router-dom";
import { NotFound } from "navigation/NotFound";
import { Home } from "features/home";
import { FEEDBACK, OSCE, RATING_INSTRUMENTS, ROOT } from "./Paths";
import { RatingInstruments } from "features/rating_instruments/RatingInstruments";
import { OSCEPage } from "features/rating_instruments/contexts/OSCEPage";
import { GRSRoutes } from "features/rating_instruments/instruments/GRS/GRSRoutes";
import { PSCRoutes } from "features/rating_instruments/instruments/PSC/PSCRoutes";
import { Feedback } from "features/feedback";

export const RouterConfig = () => {
  return (
    <Routes>
      <Route path={ROOT} element={<Home />} />
      <Route path={FEEDBACK} element={<Feedback />} />
      <Route path={RATING_INSTRUMENTS} element={<Outlet />}>
        <Route index element={<RatingInstruments />} />
        <Route path={OSCE} element={<Outlet />}>
          <Route index element={<OSCEPage />} />
          {GRSRoutes({ context: "osce" })}
          {PSCRoutes({ context: "osce" })}
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
